import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
  importProvidersFrom,
  APP_INITIALIZER,
} from '@angular/core';
import { provideRouter, withDebugTracing, withHashLocation } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';
import { AuthInterceptor } from './shared/interceptors/auth.interceptor';
import { TokenService } from './shared/services/token-service';

import { registerLocaleData } from '@angular/common';
import zh from '@angular/common/locales/zh';
import { provideToastr } from 'ngx-toastr';

import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
registerLocaleData(zh);

// APP_INITIALIZER 函數：在應用啟動時檢查 URL 中的 token
function checkUrlToken(tokenService: TokenService): () => void {
  return () => {
    console.log('[APP_INITIALIZER] 檢查 URL 中的 token');
    const hash = window.location.hash;
    if (hash.includes('token=')) {
      try {
        const hashParts = hash.split('?');
        const queryString = hashParts[1];
        if (queryString) {
          const params = new URLSearchParams(queryString);
          const token = params.get('token');
          if (token) {
            console.log('[APP_INITIALIZER] 找到 URL token，正在設置');
            tokenService.setLogonToken(token);
            // 清理 URL
            const cleanHash = hashParts[0];
            window.history.replaceState({}, '', window.location.pathname + cleanHash);
          }
        }
      } catch (error) {
        console.error('[APP_INITIALIZER] 處理 URL token 時出錯:', error);
      }
    }
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()), // ✅ 攔截器才會動
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: CookieService, useClass: CookieService },
    // provideNzI18n(zh_TW),
    provideAnimationsAsync(),
    provideToastr({
      // 在這裡設定 Toastr
      timeOut: 3000,
      positionClass: 'toast-top-right',
      preventDuplicates: true,      
    }),
    {
      provide: APP_INITIALIZER,
      useFactory: checkUrlToken,
      deps: [TokenService],
      multi: true,
    },
  ],
};
